import React from "react";
import { useTranslations } from "next-intl";
import dayjs from "dayjs";

import { useTheme } from "@/context/Theme.context";
import { sidebarFooterItems } from "../utils/sidebarMenuItems";

const SidebarFooter = () => {
  const t = useTranslations();
  const theme = useTheme();

  return (
    <footer>
      <div className="mb-8 h-px w-full bg-white opacity-10" />
      <ul className="h-14f flex flex-row flex-wrap items-center gap-2 px-6 py-4">
        {sidebarFooterItems.map((item) => {
          if (!item?.[theme]) {
            return null;
          }

          const Icon = item.icon;
          return (
            <li key={item.title}>
              <a
                href={item?.[theme] as string}
                target="_blank"
                rel="noreferrer"
              >
                <div className="flex h-10 w-10 items-center justify-center rounded-[32px] bg-[#293e42]">
                  <Icon />
                </div>
              </a>
            </li>
          );
        })}
      </ul>
      <div className="mt-1">
        <span className="text-sm leading-normal text-[#617074]">
          {t("copyright")} {dayjs().year()}
          <br />
          {t("developed_by")}{" "}
        </span>
        <span className="ms-1 text-sm font-bold leading-normal text-white">
          Qwerty
        </span>
      </div>
    </footer>
  );
};

export default SidebarFooter;
